import React from 'react';
import {
  Row, Col, Form, Input,
} from 'antd';
import CurrencyInput from 'react-currency-input';
import moment from 'moment';
import PropTypes from 'prop-types';
import { getUserType } from '../../../../../../utils/users';
import PrnOxidoField from '../../../../serviceComponents/fieldComponents/prntOxido/PrntOxido';
import PrnCalcarioField from '../../../../serviceComponents/fieldComponents/prntCalcario/PrntCalcario';
import VDesejado from '../../../../serviceComponents/fieldComponents/vDesenjado/VDesejado';
import MaturadorField from '../../../../serviceComponents/fieldComponents/maturador/Maturador';
import NomeProdutoField from '../../../../serviceComponents/fieldComponents/nomeProduto/NomeProduto';
import TombamentoField from '../../../../serviceComponents/fieldComponents/tombamento/Tombamento';
import DataPlantioField from '../../../../serviceComponents/fieldComponents/dataPlantio/DataPlantio';
import EstagioCorte from '../../../../serviceComponents/fieldComponents/estagioCorte/EstagioCorte';
import VariedadeField from '../../../../serviceComponents/fieldComponents/variedade/Variedade';
import './DetailsEdit.scss';

const DetailsEdit = (props) => {
  const {
    formInstance,
    initialValuesObject,
    edit,
    detail,
  } = props;

  return (
    <>
      <Row
        gutter={[24, 24]}
        className="GeofertZonaManejoSateliteDetails__FirstFieldRow"
      >
        <Col
          xs={{ span: 24 }}
          className="GeofertZonaManejoSateliteDetails__FirstFieldColumn"
        >
          <VDesejado
            min={0}
            max={100}
            name="GEOFERT-ZONA_MANEJO-SATELITE-V_DESEJADO"
            value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-SATELITE-V_DESEJADO']}
            edit={edit}
            rules={[]}
          />
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="GeofertZonaManejoSateliteDetails__FirstFieldRow"
      >
        <Col
          xs={{ span: 24 }}
          className="GeofertZonaManejoSateliteDetails__FirstFieldColumn"
        >
          <PrnCalcarioField
            min={0}
            max={100}
            name="GEOFERT-ZONA_MANEJO-SATELITE-PRNT_CALCARIO"
            value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-SATELITE-PRNT_CALCARIO']}
            rules={[]}
            edit={edit}
          />
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="GeofertZonaManejoSateliteDetails__FirstFieldRow"
      >
        <Col
          xs={{ span: 24 }}
          className="GeofertZonaManejoSateliteDetails__FirstFieldColumn"
        >
          <PrnOxidoField
            min={130}
            max={180}
            name="GEOFERT-ZONA_MANEJO-SATELITE-PRNT_OXIDO"
            value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-SATELITE-PRNT_OXIDO']}
            rules={[]}
            edit={edit}
          />
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="GeofertZonaManejoSateliteDetails__FirstFieldRow"
      >
        <Col
          xs={{ span: 24 }}
          className="GeofertZonaManejoSateliteDetails__FirstFieldColumn"
        >
          <VariedadeField
            name="GEOFERT-ZONA_MANEJO-VARIEDADE"
            label="Variedade"
            edit={edit}
            rules={[
              {
                required: true, message: 'O campo é obrigatório',
              },
            ]}
            value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-VARIEDADE']}
          />
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="GeofertZonaManejoSateliteDetails__FirstFieldRow"
      >
        <Col
          xs={{ span: 24 }}
          className="GeofertZonaManejoSateliteDetails__FirstFieldColumn"
        >
          <EstagioCorte
            min={1}
            max={20}
            name="GEOFERT-ZONA_MANEJO-ESTAGIO_CORTE"
            nameData1="GEOFERT-ZONA_MANEJO-DATA_ULTIMO_CORTE"
            nameData2="GEOFERT-ZONA_MANEJO-DATA_PENULTIMO_CORTE"
            label="Estágio de corte"
            labelData1="Data do último corte"
            labelData2="Data do penúltimo corte"
            date1min="2"
            date2min="3"
            estagioCorteValue={initialValuesObject?.['GEOFERT-ZONA_MANEJO-ESTAGIO_CORTE']}
            dataUltimoCorte={initialValuesObject?.['GEOFERT-ZONA_MANEJO-DATA_ULTIMO_CORTE']}
            dataPenultimoCorte={initialValuesObject?.['GEOFERT-ZONA_MANEJO-DATA_PENULTIMO_CORTE']}
            edit={edit}
            rules={[
              {
                required: true, message: 'Por favor, insira um valor entre 1 e 20',
              },
            ]}
            rulesData1={edit === false
              ? [
                {
                  required: true, message: 'O campo é obrigatório',
                },
                {
                  validator: (b, value) => {
                    const finalDate = moment().format('DD/MM/YYYY');
                    const dateFormat = 'DD/MM/YYYY';

                    if (!(moment(value).endOf('day') <= moment(finalDate, dateFormat).endOf('day'))) {
                      return Promise.reject(new Error(`Insira uma data menor ou igual a ${finalDate}`));
                    }
                    return Promise.resolve();
                  },
                },
              ]
              : null}
            rulesData2={edit === false
              ? [
                {
                  required: true, message: 'O campo é obrigatório',
                },
                {
                  validator: (b, value) => {
                    const finalDate = moment().format('DD/MM/YYYY');
                    const dateFormat = 'DD/MM/YYYY';

                    if (!(moment(value).endOf('day') <= moment(finalDate, dateFormat).endOf('day'))) {
                      return Promise.reject(new Error(`Insira uma data menor ou igual a ${finalDate}`));
                    }
                    return Promise.resolve();
                  },
                },
              ]
              : null}
          />
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="GeofertZonaManejoSateliteDetails__FirstFieldRow"
      >
        <Col
          xs={{ span: 24 }}
          className="GeofertZonaManejoSateliteDetails__FirstFieldColumn"
        >
          <DataPlantioField
            name="GEOFERT-ZONA_MANEJO-DATA_PLANTIO"
            label="Data de plantio"
            edit={edit}
            value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-DATA_PLANTIO']}
            rules={edit === false
              ? [
                {
                  required: true, message: 'O campo é obrigatório',
                },
                {
                  validator: (b, value) => {
                    const finalDate = moment().format('DD/MM/YYYY');
                    const dateFormat = 'DD/MM/YYYY';

                    if (!(moment(value).endOf('day') <= moment(finalDate, dateFormat).endOf('day'))) {
                      return Promise.reject(new Error(`Insira uma data menor ou igual a ${finalDate}`));
                    }

                    return Promise.resolve();
                  },
                },
              ]
              : null}
          />
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="GeofertZonaManejoSateliteDetails__FirstFieldRow"
      >
        <Col
          xs={{ span: 24 }}
          className="GeofertZonaManejoSateliteDetails__FirstFieldColumn"
        >
          <TombamentoField
            name="GEOFERT-ZONA_MANEJO-HOUVE_TOMBAMENTO"
            label="Houve tombamento?"
            nameData="GEOFERT-ZONA_MANEJO-DATA_TOMBAMENTO"
            labelData="Data de tombamento"
            edit={edit}
            formInstance={formInstance}
            rules={[]}
            rulesData={edit === false
              ? [
                {
                  validator: (b, value) => {
                    const finalDate = moment().format('DD/MM/YYYY');
                    const dateFormat = 'DD/MM/YYYY';

                    if (!(moment(value).endOf('day') <= moment(finalDate, dateFormat).endOf('day'))) {
                      return Promise.reject(new Error(`Insira uma data menor ou igual a ${finalDate}`));
                    }

                    return Promise.resolve();
                  },
                },
              ]
              : null}
            value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-HOUVE_TOMBAMENTO']}
            valueData={initialValuesObject?.['GEOFERT-ZONA_MANEJO-DATA_TOMBAMENTO']}
          />
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="GeofertZonaManejoSateliteDetails__FirstFieldRow"
      >
        <Col
          xs={{ span: 24 }}
          className="GeofertZonaManejoSateliteDetails__FirstFieldColumn"
        >
          <MaturadorField
            name="GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR"
            label="Houve aplicação de maturador?"
            nameData="GEOFERT-ZONA_MANEJO-DATA_APLICACAO_MATURADOR"
            labelData="Data da aplicação de maturador"
            edit={edit}
            rules={[]}
            rulesData={edit === false
              ? [
                {
                  validator: (b, value) => {
                    const finalDate = moment().format('DD/MM/YYYY');
                    const dateFormat = 'DD/MM/YYYY';

                    if (!(moment(value).endOf('day') <= moment(finalDate, dateFormat).endOf('day'))) {
                      return Promise.reject(new Error(`Insira uma data menor ou igual a ${finalDate}`));
                    }

                    return Promise.resolve();
                  },
                },
              ]
              : null}
            value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR']}
            valueData={initialValuesObject?.['GEOFERT-ZONA_MANEJO-DATA_APLICACAO_MATURADOR']}
          />
        </Col>
      </Row>
      <Form.Item
        noStyle
        shouldUpdate={
          (previousValues, currentValues) => {
            return currentValues['GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR']
              !== previousValues['GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR'];
          }
        }
      >
        {
          (formInstanceParameter) => {
            if (
              formInstanceParameter.getFieldValue('GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR') === true
              || formInstanceParameter.getFieldValue('GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR') === 'true'
            ) {
              return (
                <Row
                  gutter={[24, 24]}
                  className="GeofertZonaManejoSateliteDetails__FirstFieldRow"
                >
                  <Col
                    xs={{ span: 24 }}
                    className="GeofertZonaManejoSateliteDetails__FirstFieldColumn"
                  >
                    <NomeProdutoField
                      name="GEOFERT-ZONA_MANEJO-NOME_PRODUTO_UTILIZADO_APLICACAO_MATURADOR"
                      label="Nome do produto utilizado"
                      edit={edit}
                      rules={[]}
                      value={initialValuesObject?.['GEOFERT-ZONA_MANEJO-NOME_PRODUTO_UTILIZADO_APLICACAO_MATURADOR']}
                    />
                  </Col>
                </Row>
              );
            }

            return null;
          }
        }
      </Form.Item>

      {
        getUserType() === 'COOPERCITRUS' && !detail
        && (
          <>
            <Row gutter={[24, 24]}>
              <Col xs={{ span: 24 }}>
                <hr />
                <p className="GeofertZonaManejoSateliteDetails__SessionTitle">Orçamento</p>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="GeofertZonaManejoSateliteDetails__FirstFieldRow"
            >
              <Col
                xs={{ span: 24 }}
                className="GeofertZonaManejoSateliteDetails__FirstFieldColumn"
              >
                <Form.Item
                  detail={detail}
                  className="GeofertZonaManejoSateliteDetails__DesiredSizeFormItem"
                  label={<span className="field-title-text">Valor unitário</span>}
                  name="GEOFERT-ZONA-MANEJO-SATELITE-VALOR_UNITARIO"
                  rules={[
                    {
                      validator: (rule, value) => {
                        if (value < 0) {
                          return Promise.reject(new Error('Deve ser um numero maior que zero'));
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                  initialValue={
                    (
                      initialValuesObject?.['GEOFERT-ZONA-MANEJO-SATELITE-VALOR_UNITARIO']
                        ? initialValuesObject['GEOFERT-ZONA-MANEJO-SATELITE-VALOR_UNITARIO'].replaceAll('.', ',')
                        : '0,00'
                    )
                  }
                >
                  <CurrencyInput
                    allowEmpty="true"
                    className="ant-input"
                    decimalSeparator=","
                    thousandSeparator="."
                    placeholder="0,00"
                    step={0.01}
                    min={0}
                    disabled={edit}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="GeofertZonaManejoSateliteDetails__FirstFieldRow"
            >
              <Col
                xs={{ span: 24 }}
                className="GeofertZonaManejoSateliteDetails__FirstFieldColumn"
              >
                <Form.Item
                  className="GeofertZonaManejoSateliteDetails__DesiredSizeFormItem"
                  label={<span className="field-title-text">Valor total</span>}
                  name="GEOFERT-ZONA-MANEJO-SATELITE-VALOR_TOTAL"
                  rules={[
                    {
                      validator: (rule, value) => {
                        if (value < 0) {
                          return Promise.reject(new Error('Deve ser um numero maior que zero'));
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                  initialValue={
                    (
                      initialValuesObject?.['GEOFERT-ZONA-MANEJO-SATELITE-VALOR_TOTAL']
                        ? initialValuesObject['GEOFERT-ZONA-MANEJO-SATELITE-VALOR_TOTAL'].replaceAll('.', ',')
                        : '0,00'
                    )
                  }
                >
                  <CurrencyInput
                    allowEmpty="true"
                    className="ant-input"
                    decimalSeparator=","
                    thousandSeparator="."
                    placeholder="0,00"
                    step={0.01}
                    min={0}
                    disabled={edit}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="GeofertZonaManejoSateliteDetails__FirstFieldRow"
            >
              <Col
                xs={{ span: 24 }}
                className="GeofertZonaManejoSateliteDetails__FirstFieldColumn"
              >
                <Form.Item
                  className="GeofertZonaManejoSateliteDetails__DesiredSizeFormItem"
                  label={<span className="field-title-text">Condição de pagamento</span>}
                  name="GEOFERT-ZONA-MANEJO-SATELITE-CONDICAO_PAGAMENTO"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['GEOFERT-ZONA-MANEJO-SATELITE-CONDICAO_PAGAMENTO']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength="255"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="GeofertZonaManejoSateliteDetails__FirstFieldRow"
            >
              <Col
                xs={{ span: 24 }}
                className="GeofertZonaManejoSateliteDetails__FirstFieldColumn"
              >
                <Form.Item
                  className="GeofertZonaManejoSateliteDetails__DesiredSizeFormItem"
                  label={<span className="field-title-text">Forma de pagamento</span>}
                  name="GEOFERT-ZONA-MANEJO-SATELITE-FORMA_PAGAMENTO"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['GEOFERT-ZONA-MANEJO-SATELITE-FORMA_PAGAMENTO']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength="255"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="GeofertZonaManejoSateliteDetails__FirstFieldRow"
            >
              <Col
                xs={{ span: 24 }}
                className="GeofertZonaManejoSateliteDetails__FirstFieldColumn"
              >
                <Form.Item
                  className="GeofertZonaManejoSateliteDetails__DesiredSizeFormItem"
                  label={<span className="field-title-text">Observações do orçamento</span>}
                  name="GEOFERT-ZONA-MANEJO-SATELITE-OBSERVACOES"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['GEOFERT-ZONA-MANEJO-SATELITE-OBSERVACOES']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength="255"
                  />
                </Form.Item>
              </Col>
            </Row>
          </>
        )
      }
    </>
  );
};

DetailsEdit.propTypes = {
  formInstance: PropTypes.shape({}).isRequired,
  initialValuesObject: PropTypes.shape({
    'GEOFERT-ZONA_MANEJO-SATELITE-PRNT_OXIDO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA_MANEJO-SATELITE-PRNT_CALCARIO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA_MANEJO-SATELITE-V_DESEJADO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA_MANEJO-HOUVE_APLICACAO_MATURADOR': PropTypes.oneOfType([PropTypes.oneOf(['true', 'false']), PropTypes.bool]),
    'GEOFERT-ZONA_MANEJO-DATA_APLICACAO_MATURADOR': PropTypes.any,
    'GEOFERT-ZONA_MANEJO-NOME_PRODUTO_UTILIZADO_APLICACAO_MATURADOR': PropTypes.string,
    'GEOFERT-ZONA_MANEJO-HOUVE_TOMBAMENTO': PropTypes.oneOf(['true', 'false']),
    'GEOFERT-ZONA_MANEJO-DATA_TOMBAMENTO': PropTypes.any,
    'GEOFERT-ZONA_MANEJO-DATA_PLANTIO': PropTypes.any,
    'GEOFERT-ZONA_MANEJO-ESTAGIO_CORTE': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA_MANEJO-DATA_ULTIMO_CORTE': PropTypes.any,
    'GEOFERT-ZONA_MANEJO-DATA_PENULTIMO_CORTE': PropTypes.any,
    'GEOFERT-ZONA_MANEJO-VARIEDADE': PropTypes.string,
    'GEOFERT-ZONA-MANEJO-SATELITE-VALOR_UNITARIO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA-MANEJO-SATELITE-VALOR_TOTAL': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA-MANEJO-SATELITE-CONDICAO_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA-MANEJO-SATELITE-FORMA_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-ZONA-MANEJO-SATELITE-OBSERVACOES': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  edit: PropTypes.bool,
  detail: PropTypes.bool,
};
DetailsEdit.defaultProps = {
  detail: false,
};

export default DetailsEdit;
